import { render, staticRenderFns } from "./examine-approve.vue?vue&type=template&id=37fcea5e&scoped=true"
import script from "./examine-approve.vue?vue&type=script&lang=js"
export * from "./examine-approve.vue?vue&type=script&lang=js"
import style0 from "./examine-approve.vue?vue&type=style&index=0&id=37fcea5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fcea5e",
  null
  
)

export default component.exports